import { hotList } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function HotList() {
  return (
    <section id="hot" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="01"
          eyebrow="Trending"
          title="热点追踪"
          desc="把热度重新放回上下文里。我们记录正在升温的选题，也告诉你这阵热度之下，还有什么值得盯住的结构变化。"
          right={
            <a
              href="#columns"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              全部深度栏目
              <i className="ri-arrow-right-line" />
            </a>
          }
        />

        <div className="grid gap-5 lg:grid-cols-2">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold">
              <span className="h-2 w-2 rounded-full bg-primary-500" />
              本周关键动向
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本周热点集中在「换血信号」「逆势补货」与「留白解读」三条主线上。
              我们建议先读《从公开财报倒推三步资本动作》，再进入图谱专题，
              两条线索彼此咬合，能更快拼出完整轮廓。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["公开档案", "资本动作", "时间戳", "关系连线"].map((t) => (
                <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                  #{t}
                </span>
              ))}
            </div>
          </div>

          <ol className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
            {hotList.map((h) => (
              <li key={h.rank}>
                <a
                  href="#columns"
                  className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-5"
                >
                  <span className="w-9 shrink-0 text-center font-heading text-2xl font-black text-background-300 transition-colors group-hover:text-primary-500">
                    {String(h.rank).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground-950 md:text-base">{h.title}</p>
                    <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded bg-accent-100 px-1.5 py-0.5 text-accent-900">{h.tag}</span>
                      <span>{h.delta}</span>
                    </p>
                  </div>
                  <div className="flex shrink-0 flex-col items-end gap-1">
                    <span className="flex items-center gap-1 text-xs text-primary-600">
                      <i className="ri-fire-line" />
                      {h.heat}
                    </span>
                    <i className="ri-arrow-right-line text-background-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
                  </div>
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}